module.exports = __webpack_public_path__ + "img/code5.58a34872.png";